import * as React from "react";
import { PageUrl } from "src/routes/PageUrl";

import {
  ManagementSpecCommonCard,
  ManagementSpecCommonCardStore,
} from "../../ManagementSpecCommon/ManagementSpecCommonCard";

const pageStore = new ManagementSpecCommonCardStore({
  specType: "secondary",
  newTitle: "Новая вторичная спецификация",
  middleCrumb: { type: "AdminSecondSpecs" },
});

export const ManagementSecondSpecCard: React.FC = () => (
  <ManagementSpecCommonCard
    pageStore={pageStore}
    listUrl={PageUrl.managementSecondSpecs}
    cardUrl={PageUrl.managementSecondSpecCard}
  />
);
